export default __webpack_public_path__ + "sun.png";